import { IKnmChecklistKnoOrganization } from 'APIPackage/KnmModule/interfaces/IKnmChecklistKnoOrganization';
import { IKnoOrganisationSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnoOrganisationSelectOption';

export const createKnmChecklistKnoOrganisationSelectOption = (
  knmChecklistKnoOrganisation: IKnmChecklistKnoOrganization,
): IKnoOrganisationSelectOption => ({
  id: knmChecklistKnoOrganisation.id,
  fullName: knmChecklistKnoOrganisation.fullName,
  label: knmChecklistKnoOrganisation.fullName,
  value: knmChecklistKnoOrganisation.id,
});
